import { atom } from "recoil";

export const getProjects = atom({
  key: "getProjects",
  default: [],
});
